
import React, { useEffect, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import Review from "../Review"
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "./styles.css"

import {REVIEWS} from "../../constant"
// import required modules
import { Navigation } from "swiper";
import quote from "../../images/svg/blackquote.svg"

const CustomerReviews = () => {
    const [slidePerView,setSlidePerView]=useState(2);
    useEffect(() => {
    if (window.innerWidth< 1300)
    setSlidePerView(1);
    },[slidePerView])
  return (
    <>
      <Swiper navigation={true} modules={[Navigation]}
       className="mySwiper"
         style={{
          "--swiper-navigation-color": "#d2a960",
          "--swiper-pagination-color": "#d2a960"}}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={slidePerView}
        loop={true}
        pagination={{
          clickable: true,
        }}>
        
        {REVIEWS.map((review,i)=>{
            return(
        <SwiperSlide key={i}>
            <div className="container bg-white w-full m-10 p-10">
        <img className="mx-auto p-5 bg-cover" src={quote} width="50px" height="50px" alt="quote"/>
           <div className="py-10">
                {review.content}
            </div>
            
    <div class="flex items-center m-4">
        <a href="#" class="block relative">
            <img alt="profil" src="/images/person/1.jpg" class="mx-auto object-cover rounded-full h-10 w-10 "/>
        </a>
        <div class="flex flex-col ml-2 justify-between p-5">
            <span class="font-semibold text-black text-xl">
                {review.gname}
            </span>
            <span class=" text-lg flex items-center">
                {review.person}
               
            </span>
        </div>
        </div>
    </div>


        </SwiperSlide>
            )})}
      
      </Swiper>
    </>
  );
}
export default CustomerReviews